export const visit = (vm, at) => {
at({ "pl": { "conversationsVisitorUIPageTitleNotifications": { "newMessage": "Nowa wiadomo\u015B\u0107" } } });
};